export default "__VITE_ASSET__Tt9EMJu6__"